export const NAVICARGO_PHONE = "+52 33 2258 4766";
export const NAVICARGO_PHONE_LINK = "tel:+523322584766";
export const NAVICARGO_EMAIL = "contacto@navicargologistics.com";
export const NAVICARGO_EMAIL_LINK = `mailto:${NAVICARGO_EMAIL}`;
export const NAVICARGO_WHATSAPP = "https://wa.me/523322584766";

export const getWhatsAppLink = (message = "Hola Navicargo, me gustaría solicitar una cotización.") =>
  `${NAVICARGO_WHATSAPP}?text=${encodeURIComponent(message)}`;